import '../vendor';

import '../general/ofi';
import '../general/anchor';
import '../general/menu.js';
import '../general/find';
import '../general/search-clear';
import '../general/aside-filter';
import '../general/filters';
import '../general/aside-inputs';


// WEBPACK FOOTER //
// ./src/js/pages/themes.js